import { FilterInputProps } from '@/components/table/_fieldDefinitions/_base/FilterInputProps.ts';
import MultiSelectInput from '@/components/form/MultiSelectInput.tsx';
import { RegistrationStatus } from '@/features/dashboard/tours/types/RegistrationStatus.ts';
import { registrationDetailsTsUtils } from '@/features/dashboard/tours/types/RegistrationDetails.ts.utils.ts';

// Opcje generowane z enuma — kolejna wartość statusu dołoży się sama.
const registrationStatusOptions = Object.values(RegistrationStatus).map(
  (status) => ({
    value: status,
    label: registrationDetailsTsUtils.getLabel(status),
  }),
);

export const RegistrationModeFilterInput = ({
  form,
  index,
}: FilterInputProps) => (
  <MultiSelectInput
    controlSize="toolbar"
    placeholder="Wpisz wartość"
    fieldPath={`filters.${index}.value`}
    control={form.control}
    options={registrationStatusOptions}
  />
);
